module.exports = __webpack_public_path__ + "img/icon-user.5265d8.png";